'use strict'

const React = require('react')
const PropTypes = require('prop-types')
const baseImage = require('./images/login-wombat-base.png')
const faceBaseImage = require('./images/login-wombat-face-base.png')
const faceBlinkImage = require('./images/login-wombat-face-blink.png')
const faceHappyImage = require('./images/login-wombat-face-happy.png')
const styles = require('./styles/wombat.css')
const globalStyles = require('../../../styles/global.css')

const Wombat = props => {
  const {onClick} = props

  const faceMarkup = (
    <div className={styles.animationFaceBounce}>
      <div className={styles.wombatFace}>
        <img src={faceBaseImage} alt="" role="presentation" className={styles.wombatFaceBase} />
        <img src={faceBlinkImage} alt="" role="presentation" className={styles.wombatFaceBlink} />
        <img src={faceHappyImage} alt="" role="presentation" className={styles.wombatFaceHappy} />
      </div>
    </div>
  )

  const handleOnClick = event => {
    event.preventDefault()
    onClick(event)
    return false
  }

  return (
    <button className={`${styles.wombat} ${globalStyles.clean}`} onClick={handleOnClick}>
      {faceMarkup}
      <img alt="" role="presentation" src={baseImage} />
    </button>
  )
}

Wombat.propTypes = {
  onClick: PropTypes.func,
}
Wombat.defaulProps = {
  onClick: () => {},
}

module.exports = Wombat
